import { useCallback, useContext } from 'react';
import { NotificationContext } from '../contexts/NotificationContext';
import { useTranslation } from 'react-i18next';

export const useCopyToCliboard = () => {
  const { t } = useTranslation();
  const { addNotification } = useContext(NotificationContext);

  return useCallback((value: string, label: string) => {
    navigator.clipboard.writeText(value);
    addNotification({
      severity: 'success',
      message: t('component.copyTextField.copyConfirmation', { item: label }),
    });
  }, []);
};
